module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Select bibliography")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("These are the works frequently referred to and which are cited in the text by the last name of the author.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Old Testament introductions")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Childs, B. S., "), _c('i', [_vm._v("Introduction to the Old Testament as Scripture ")]), _vm._v("(SCM, 1983. US ed. Philadelphia: Fortress Press, 1979).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Crenshaw, J. L., "), _c('i', [_vm._v("Story and Faith: A Guide to the Old Testament ")]), _vm._v("(New York and London: Macmillan Publishing Co., 1986).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Gottwald, N. K., "), _c('i', [_vm._v("The Hebrew Bible: A Socio-Literary Introduction")]), _vm._v(" (Philadelphia: Fortress Press, 1985).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Kaiser, O., "), _c('i', [_vm._v("Introduction to the Old Testament: A Presentation of Its Results and Problems ")]), _vm._v("(E.T., Blackwell, 1980. US ed. Minneapolis: Augsburg Publishing House, 1975).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Robert, A. and Feuillet, A., "), _c('i', [_vm._v("Introduction to the Old Testament ")]), _vm._v("(E.T., New York: Desclee Co., 1968).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Soggin, J. A., "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(", OTL (E.T., SCM, 1988. US ed. Philadelphia: Westminster Press, 1976).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Weiser, A., "), _c('i', [_vm._v("The Old Testament: Its Formation and Development ")]), _vm._v("(E.T., New York: Association Press, 1961). (Cited as Weiser, "), _c('i', [_vm._v("Old Testament")]), _vm._v(".)")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Old Testament histories")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Bright, J., "), _c('i', [_vm._v("A History of Israel ")]), _vm._v("(SCM, 2nd rev. ed., 1981. US ed. Philadelphia: Westminster Press, "), _c('sup', [_vm._v("3")]), _vm._v("1981).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Donner, H., ‘The Separate States of Israel and Judah’ in "), _c('i', [_vm._v("Israelite and Judaean History")]), _vm._v(", ed. by J. H. Hayes and J. M. Miller, OTL (Philadelphia: Westminster Press, 1977), pp. 381–434.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Herrmann, S., "), _c('i', [_vm._v("A History of Israel in Old Testament Times ")]), _vm._v("(E.T., Philadelphia: Fortress Press, "), _c('sup', [_vm._v("2")]), _vm._v("1981).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Miller, J. M. and Hayes, J. H., "), _c('i', [_vm._v("A History of Ancient Israel and Judah")]), _vm._v(" (SCM, 1986. US ed. Philadelphia: Westminster Press, 1986).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Old Testament theologies")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Jacob, E., "), _c('i', [_vm._v("Theology of the Old Testament ")]), _vm._v("(E.T., London: Hodder, 1958. US ed. New York: Harper and Brothers, 1958).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Rad, G. von, "), _c('i', [_vm._v("Old Testament Theology")]), _vm._v(", 2 vols. (E.T., Edinburgh: Oliver and Boyd, 1962, 1965. US ed. New York: Harper and Row, 1962, 1965).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Vriezen, Th. C., "), _c('i', [_vm._v("An Outline of Old Testament Theology ")]), _vm._v("(E.T., Oxford: Blackwell, "), _c('sup', [_vm._v("2")]), _vm._v("1970. US ed. Newton, Mass.: C. T. Branford, "), _c('sup', [_vm._v("2")]), _vm._v("1970).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Zimmerli, W., "), _c('i', [_vm._v("Old Testament Theology in Outline ")]), _vm._v("(E.T., n.e., Edinburgh: T. and T. Clark, 1983. US ed. Atlanta: John Knox Press, "), _c('sup', [_vm._v("2")]), _vm._v("1978).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Works on the prophets")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Blenkinsopp, J., "), _c('i', [_vm._v("A History of Prophecy in Israel ")]), _vm._v("(SPCK, 1984. US ed. Philadelphia: Westminster Press, 1983).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Buber, M., "), _c('i', [_vm._v("The Prophetic Faith ")]), _vm._v("(New York: Harper & Brothers, 1949).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Clements, R. E., "), _c('i', [_vm._v("Prophecy and Tradition ")]), _vm._v("(Blackwell, 1975. US ed. Atlanta: John Knox Press, 1975).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Coggins, R., ‘An Alternative Prophetic Tradition?’ in "), _c('i', [_vm._v("Israel’s Prophetic Tradition: Essays in Honour of Peter Ackroyd")]), _vm._v(", ed. by R. Coggins, A. Phillips and M. Knibb (Cambridge University Press, 1984), pp. 77–94.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Gordis, R., "), _c('i', [_vm._v("Poets")]), _vm._v(", "), _c('i', [_vm._v("Prophets and Sages: Essays in Biblical Interpretation")]), _vm._v(" (Bloomington and London: Indiana University Press, 1971).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Hanson, P. D., "), _c('i', [_vm._v("The People Called: the Growth of Community in the Bible")]), _vm._v(" (San Francisco: Harper & Row, 1986).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Heschel, A. J., "), _c('i', [_vm._v("The Prophets ")]), _vm._v("(New York and Evanston: Harper & Row, 1962).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Hunter, A. V., "), _c('i', [_vm._v("Seek the Lord! A Study of the Meaning and Function of the Exhortations in Amos")]), _vm._v(", "), _c('i', [_vm._v("Hosea")]), _vm._v(", "), _c('i', [_vm._v("Micah and Zephaniah ")]), _vm._v("(Baltimore: St Mary’s Seminary & University, 1982).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Koch, K., "), _c('i', [_vm._v("The Prophets: vol. 1. The Assyrian Period ")]), _vm._v("(E.T., SCM, 1982. US ed. Philadelphia: Fortress Press, 1983).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Kuhl, C. "), _c('i', [_vm._v("The Prophets of Israel ")]), _vm._v("(E.T., Edinburgh and London: Oliver and Boyd, 1960).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Murray, R., ‘Prophecy and the Cult’ in "), _c('i', [_vm._v("Israel’s Prophetic Tradition")]), _vm._v(", pp. 200–216.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Nicholson, E. W., "), _c('i', [_vm._v("God and His People: Covenant and Theology in the Old Testament ")]), _vm._v("(Oxford: Clarendon Press, and New York: Oxford University Press, 1986).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Phillips, A., ‘Prophecy and Law’ in "), _c('i', [_vm._v("Israel’s Prophetic Tradition")]), _vm._v(", pp. 217–232.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Sawyer, J. F. A., ‘A Change of Emphasis in the Study of the Prophets’ in "), _c('i', [_vm._v("Israel’s Prophetic Tradition")]), _vm._v(", pp. 233–249.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Van der Woude, A. S., ‘Three Classical Prophets: Amos, Hosea and Micah’ in "), _c('i', [_vm._v("Israel’s Prophetic Tradition")]), _vm._v(", pp. 32–57.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Vuilleumier, R., "), _c('i', [_vm._v("La tradition cultuelle d’Israël dans la prophétie d’Amos et d’Osée")]), _vm._v(", Cahiers Théologiques 45 (Neuchâtel: Editions Delachaux & Niestlé, 1960).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Whybray, R. N., ‘Prophecy and Wisdom’ in "), _c('i', [_vm._v("Israel’s Prophetic Tradition")]), _vm._v(", pp. 181–199.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Joel: commentaries")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Allen, L., "), _c('i', [_vm._v("The Books of Joel")]), _vm._v(", "), _c('i', [_vm._v("Obadiah")]), _vm._v(", "), _c('i', [_vm._v("Jonah and Micah")]), _vm._v(", NICOT (Grand Rapids: Eerdmans, 1976).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Bewer, J. A., "), _c('i', [_vm._v("Joel et al")]), _vm._v("., ICC (Edinburgh: T. & T. Clark, 1911).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Bič, M., "), _c('i', [_vm._v("Das Buck Joel ")]), _vm._v("(Berlin: Evangelische Verlaganstalt, 1960)")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Delcor, M., ‘Joel’ in "), _c('i', [_vm._v("Les Petits Prophètes")]), _vm._v(", La Sainte Bible (Paris: Letouzey & Ané, 1961)")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Driver, S. R., "), _c('i', [_vm._v("Joel and Amos")]), _vm._v(", The Cambridge Bible for Schools and Colleges (Cambridge: The University Press, 1898).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Kapelrud, A. S., "), _c('i', [_vm._v("Joel Studies")]), _vm._v(", Uppsala Universitets Arsskrift 1948: 4 (Uppsala and Leipzig: A.B. Lundequistska Bok-handeln and Otto Harrassowitz, 1948).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Keil, C. F., "), _c('i', [_vm._v("The Twelve Minor Prophets")]), _vm._v(", vol. 1 in "), _c('i', [_vm._v("Biblical Commentaries on the Old Testament ")]), _vm._v("by C.F. Keil & F. Delitzsch (E.T., Reprint: Grand Rapids: Eerdmans, 1949).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Keller, C. A., "), _c('i', [_vm._v("Joel")]), _vm._v(", CAT (Neuchâtel: Editions Delachaux & Niestlé, 1965).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Robinson, T. H., "), _c('i', [_vm._v("Die Zwölf Kleinen Propheten")]), _vm._v(", HAT (Tübingen: J. C.B. Mohr [Paul Siebeck], "), _c('sup', [_vm._v("2")]), _vm._v("1954).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Rudolph, W., "), _c('i', [_vm._v("Joel")]), _vm._v(", "), _c('i', [_vm._v("Amos")]), _vm._v(", "), _c('i', [_vm._v("Obadja")]), _vm._v(", "), _c('i', [_vm._v("Jona")]), _vm._v(", KAT (Gütersloher Verlaghaus Gerd Mohn, 1971).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Sellin, E., "), _c('i', [_vm._v("Joel")]), _vm._v(", KAT (Leipzig, 1930).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Smith, G. A., "), _c('i', [_vm._v("The Book of the Twelve Prophets")]), _vm._v(", Expositor’s Bible (New York and London: Harper & Brothers, 1928).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Thompson, J. A., "), _c('i', [_vm._v("Joel")]), _vm._v(", IB (New York: Abingdon Press, 1956).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Watts, J. D. W., "), _c('i', [_vm._v("The Books of Joel")]), _vm._v(", "), _c('i', [_vm._v("Obadiah")]), _vm._v(", "), _c('i', [_vm._v("Jonah")]), _vm._v(", "), _c('i', [_vm._v("Nahum")]), _vm._v(", "), _c('i', [_vm._v("Habakkuk and Zephaniah")]), _vm._v(", CBC (Cambridge and New York: Cambridge University Press, 1975).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Wolff, H. W., "), _c('i', [_vm._v("Joel and Amos")]), _vm._v(", Hermeneia (E. T., SCM, 1977. US ed. Philadelphia: Fortress Press, 1977).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Joel: special studies")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Ahlström, G. W., "), _c('i', [_vm._v("Joel and the Temple Cult of Jerusalem")]), _vm._v(", VT Supp. 21 (Leiden: E. J. Brill, 1971).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Plöger, O., "), _c('i', [_vm._v("Theocracy and Eschatology ")]), _vm._v("(E.T., Richmond, Virginia: John Knox Press, 1968).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Prinsloo, W. S., "), _c('i', [_vm._v("The Theology of the Book of Joel")]), _vm._v(", "), _c('i', [_vm._v("BZAW 163 ")]), _vm._v("(Berlin and New York: Walter de Gruyter, 1985).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Amos: commentaries")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Amsler, S., "), _c('i', [_vm._v("Amos")]), _vm._v(", CAT (Neuchâtel: Delachaux & Niestlé, 1965). Cripps, R. S., "), _c('i', [_vm._v("A Critical and Exegetical Commentary on the Book of Amos ")]), _vm._v("(SPCK, "), _c('sup', [_vm._v("2")]), _vm._v("1955).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Delcor, M., ‘Amos’ in "), _c('i', [_vm._v("Les Petits Prophètes")]), _vm._v(", La Sainte Bible (Paris: Letouzey & Ané, 1961). Hammershaimb, E., "), _c('i', [_vm._v("The Book of Amos: A Commentary ")]), _vm._v("(E.T., Blackwell, 1970. US ed. New York: Schocken Books, 1970).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Martin-Achard, R., "), _c('i', [_vm._v("Amos")]), _vm._v(", ITC (Edinburgh and Grand Rapids: The Handsel Press Ltd and William B. Eerdmans Publ. Co., 1984). (Cited as Martin-Achard, ITC.)")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Mays, J. L., "), _c('i', [_vm._v("Amos ")]), _vm._v("(SCM, 1978. US ed. Philadelphia: Westminster Press, 1969).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Motyer, J. A., "), _c('i', [_vm._v("The Message of Amos: The Day of the Lion ")]), _vm._v("(Leicester: IVP, 1984).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Robinson, T. H., "), _c('i', [_vm._v("Die Zwölf Kleinen Propheten")]), _vm._v(", HAT (Tübingen: J. C. B., Mohr [Paul Siebeck], "), _c('sup', [_vm._v("2")]), _vm._v("1954).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Rudolph, W., "), _c('i', [_vm._v("Joel")]), _vm._v(", "), _c('i', [_vm._v("Amos")]), _vm._v(", "), _c('i', [_vm._v("Obadja, Jona")]), _vm._v(", KAT (Gütersloher Verlaghaus Gerd Mohn, 1971).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Weiser, A., "), _c('i', [_vm._v("Die Prophetie des Amos ")]), _vm._v("(Giessen: Alfred Topelmann, 1929).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Wolff, H. W., "), _c('i', [_vm._v("Joel and Amos")]), _vm._v(", Hermeneia (E.T., SCM, 1977. US ed. Philadelphia: Fortress Press, 1977).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Amos: special studies")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Auld, A. G., "), _c('i', [_vm._v("Amos")]), _vm._v(", OT Guides (Sheffield: JSOT Press, 1986).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Coote, R. B., "), _c('i', [_vm._v("Amos Among the Prophets: Composition and Theology")]), _vm._v(" (Philadelphia: Fortress Press, 1981).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Kapelrud, A. S., "), _c('i', [_vm._v("Central Ideas in Amos ")]), _vm._v("(Oslo University Press, 1971).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Martin-Achard, R., "), _c('i', [_vm._v("Amos: L’homme")]), _vm._v(", "), _c('i', [_vm._v("le message")]), _vm._v(", "), _c('i', [_vm._v("I’influence ")]), _vm._v("(Geneva: Labor et Fides, 1984).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Neher, A., "), _c('i', [_vm._v("Amos: Contribution a L’étude du Prophétisme ")]), _vm._v("(Paris: Librairie Philosophique J. Vrin, 1950).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Reventlow, H. G., "), _c('i', [_vm._v("Das Amt des Propheten bei Amos ")]), _vm._v("(Göttingen: Vandenhoeck & Ruprecht, 1962).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Vollmer, J., "), _c('i', [_vm._v("Geschichtliche Rückblicke und Motive in der Prophetie des Amos")]), _vm._v(", "), _c('i', [_vm._v("Hosea und Jesaia")]), _vm._v(", "), _c('i', [_vm._v("BZAW ")]), _vm._v("119 (Berlin: Walter de Gruyter, 1971).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Ward, J. M., "), _c('i', [_vm._v("Amos & Isaiah: Prophets of the Word of God ")]), _vm._v("(Nashville and New York: Abingdon Press, 1969).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Watts, J. D. W., "), _c('i', [_vm._v("Vision and Prophecy in Amos ")]), _vm._v("(Grand Rapids: Eerdmans Publishing Co., 1958).")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Wolff, H. W., "), _c('i', [_vm._v("Amos the Prophet: the Man and His Background ")]), _vm._v("(E.T., Philadelphia: Fortress Press, 1973). (Cited as Wolff, "), _c('i', [_vm._v("Prophet")]), _vm._v(".)")])])])])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 78
// module chunks = 0